import { render, staticRenderFns } from "./blog-7.vue?vue&type=template&id=2ce07fd4&scoped=true"
import script from "./blog-7.vue?vue&type=script&lang=js"
export * from "./blog-7.vue?vue&type=script&lang=js"
import style0 from "./blog-7.vue?vue&type=style&index=0&id=2ce07fd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce07fd4",
  null
  
)

export default component.exports